<div class="badge badge-status badge-listitem {{badgeStatusAsOrbStyleClass}}">&nbsp;</div>